import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./es.json";
import ca from "./ca.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, ca: { translation: ca } },
    fallbackLng: "es",
    supportedLngs: ["es", "ca"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "vel7o_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
